import DesktopReviewActionTypes from './actionTypes';
import DesktopReviewInvoiceReducer from './reducers';

export const DESKTOP_REVIEW_INVOICE_REDUCER_KEY = 'DESKTOP_REVIEW_INVOICE';
export { DesktopReviewActionTypes, DesktopReviewInvoiceReducer };
